﻿'use strict';

/**
* Directive for the header
* @memberOf components.headerModule
* @namespace ebHeader
*/

ebHeader.$inject = ['$window'];

function ebHeader($window) {
    // Usage: <ebHeader></ebHeader>

    var directive = {
        restrict: 'E',
        scope: false,
        templateUrl: require('./ebHeader.html'),
        controller: 'headerController',
        controllerAs: 'header'
    };
    return directive;
}


module.exports = ebHeader;


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/header/ebHeaderDirective.js
// module id = 56
// module chunks = 0